import React, { useState } from "react";
import "../../../css/dashSupport.css";

const IcoMapPin = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
const IcoPhone  = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.6 3.41 2 2 0 0 1 3.58 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.78a16 16 0 0 0 6.29 6.29l1.06-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IcoMail   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const IcoSend   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2" fill="currentColor"/></svg>;

const Support = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const errs = {};
    if (!formData.name.trim()) errs.name = "Full name is required";
    else if (!/^[A-Za-z\s]+$/.test(formData.name)) errs.name = "Name should only contain letters";
    if (!formData.email.trim()) errs.email = "Email is required";
    if (!formData.phone.trim()) errs.phone = "Phone number is required";
    else if (!/^\d+$/.test(formData.phone)) errs.phone = "Phone number must be numeric only";
    if (!formData.subject) errs.subject = "Please select an inquiry type";
    if (!formData.message.trim()) errs.message = "Message is required";
    else if (/^\d+$/.test(formData.message)) errs.message = "Message cannot be numeric only";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      alert("Form submitted successfully!");
      setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
    }
  };

  return (
    <div className="ds-support">
      {/* HEADER */}
      <div className="ds-header">
        <span className="ds-tag">SUPPORT</span>
        <h1>Contact <span className="ds-green">Salary Uncle</span></h1>
        <p>Need help? We're here for you — Mon to Sat, 9 AM to 6 PM.</p>
      </div>

      {/* GRID */}
      <div className="ds-grid">
        {/* LEFT: Contact info */}
        <aside className="ds-info">
          <div className="ds-info-card">
            <div className="ds-info-ic"><IcoMapPin /></div>
            <div>
              <h3>Our Address</h3>
              <p>AG-52, shalimar bagh, delhi-110088</p>
            </div>
          </div>

          <div className="ds-info-card">
            <div className="ds-info-ic"><IcoPhone /></div>
            <div>
              <h3>Customer Support</h3>
              <p><a href="tel:+918448980504" className="ds-link">+91 8448980504</a></p>
              <p className="ds-muted">Monday – Saturday, 9 AM to 6 PM</p>
            </div>
          </div>

          <div className="ds-info-card">
            <div className="ds-info-ic"><IcoMail /></div>
            <div>
              <h3>Email Support</h3>
              <p><a href="mailto:Customercare@salaryuncle.com" className="ds-link">Customercare@salaryuncle.com</a></p>
              <p className="ds-muted">We reply within 24 hours</p>
            </div>
          </div>

          <div className="ds-social-card">
            <h3>Get in Touch</h3>
            <div className="ds-social-row">
              <a href="https://www.facebook.com/profile.php?id=61574094973748" target="_blank" rel="noopener noreferrer" className="ds-social" aria-label="Facebook">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
              </a>
              <a href="https://x.com/Salaryuncle" target="_blank" rel="noopener noreferrer" className="ds-social" aria-label="Twitter">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.instagram.com/salary_topup" target="_blank" rel="noopener noreferrer" className="ds-social" aria-label="Instagram">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </a>
              <a href="https://www.linkedin.com/company/salary-topup/" target="_blank" rel="noopener noreferrer" className="ds-social" aria-label="LinkedIn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
              </a>
            </div>
          </div>
        </aside>

        {/* RIGHT: Form */}
        <section className="ds-form-card">
          <div className="ds-form-head">
            <h2>We're Here</h2>
            <p>We'd love to hear from you — send us a message.</p>
          </div>

          <form onSubmit={handleSubmit} className="ds-form">
            <div className="ds-row">
              <div className="ds-field">
                <label>Full Name <span>*</span></label>
                <input type="text" name="name" placeholder="Enter your full name" value={formData.name} onChange={handleChange} />
                {errors.name && <small className="ds-err">{errors.name}</small>}
              </div>
              <div className="ds-field">
                <label>Email Address <span>*</span></label>
                <input type="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} />
                {errors.email && <small className="ds-err">{errors.email}</small>}
              </div>
            </div>

            <div className="ds-row">
              <div className="ds-field">
                <label>Phone Number <span>*</span></label>
                <input type="tel" name="phone" placeholder="Enter your Phone No." value={formData.phone} onChange={handleChange} />
                {errors.phone && <small className="ds-err">{errors.phone}</small>}
              </div>
              <div className="ds-field">
                <label>Inquiry Type <span>*</span></label>
                <select name="subject" value={formData.subject} onChange={handleChange}>
                  <option value="">Select Inquiry Type</option>
                  <option value="general">General Inquiry</option>
                  <option value="support">Customer Support</option>
                  <option value="loan">Loan Assistance</option>
                  <option value="feedback">Feedback</option>
                </select>
                {errors.subject && <small className="ds-err">{errors.subject}</small>}
              </div>
            </div>

            <div className="ds-field">
              <label>Your Message <span>*</span></label>
              <textarea name="message" rows="5" placeholder="Type your message here..." value={formData.message} onChange={handleChange} />
              {errors.message && <small className="ds-err">{errors.message}</small>}
            </div>

            <button type="submit" className="ds-submit"><IcoSend /> Send Message</button>
          </form>
        </section>
      </div>
    </div>
  );
};

export default Support;
